export default __webpack_public_path__ + "static/examp4-93cd54ebf940751aca732ffb9b4e064e.gif";